import "./footerweb.css";

import facebook from "../../../assets/facebook.png";
import instagram from "../../../assets/insta.png";
import youtube from "../../../assets/youtube.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { useEffect, useState } from "react";
import { API } from "../../../config/api";
import { GET, POST } from "../../../utils/apicalls";
import { Button, Form, Input, notification } from "antd";

function FooterWeb() {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  const [openingHours, setOpeningHoursData] = useState<any>({});
  const [categoryData, setCategoryData] = useState<any>([]);
  const [form] = Form.useForm();
  const [showAllCategories, setShowAllCategories] = useState(false);
  const visibleCategories = showAllCategories ? categoryData : categoryData.slice(0, 8);

  const fetchcontactinformation = async () => {
    try {
      setIsLoading(true);
      let api = API.LIST_CONTACT_INFORMATION;
      const response: any = await GET(api, {});


      setData(response?.data?.[0] || {}); // Store the first object
    } catch (error) {
      console.error("Error fetching contact information:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchcontactinformation();
  }, []);

  const fetchOpeningHours = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.OPENING_HOURS_GET, {});
      setOpeningHoursData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOpeningHours();
  }, []);

  const fetchCategories = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.LISTING_GET_CATEGORY, {});
      setCategoryData(response?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const submitHandler = async (values: any) => {
    try {
      let obj = {

        customerName: values.customerEmail,
        customerEmail: values.customerEmail,
        mobile_number: values.customerEmail,
        customerSubject: values.message,
        message: values.message,

      };

      setIsLoading(true);
      const postRequest: any = await POST(API.CREATE_CONTACT_MESSAGE, obj);

      if (postRequest.status) {
        notification.success({ message: "message send successfully!" });
        form.resetFields();

      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const whatsappNumber = data?.Whatsapp?.replace(/\D/g, ""); // Remove all non-numeric characters

  return (
    <>
      <div className="sticky-icon">
        {/* <a className="sticky-insta" href={data?.instaLink} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} /> Instagram
        </a>
        <a className="sticky-facebook" href={data?.faceBookLink} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faFacebook} /> Facebook
        </a>
        <a className="sticky-youtube" href={data?.youtubeLink} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faYoutube} /> YouTube
        </a> */}
        <a
          className="sticky-whatsapp"
          href={`https://wa.me/${whatsappNumber}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faWhatsapp} />   WhatsApp
        </a>
      </div>

      <footer className="footer-web">
        <div className="footer-content">
          <div className="logo">
            <img src="/logo.png" alt="kerala plus" />
          </div>

          <div>
            <p>
              Kerala Plus (Innovative Retail Concepts Private Limited) is
              India’s largest online food and grocery store. With over 18,000
              products and over a 1000 brands in our catalogue you will find
              everything you are looking for.
            </p>
          </div>
          <div className="downsocial-icons">
            <ul>
              <li>
                <a href={data?.faceBookLink}>
                  <img src={facebook} alt="Facebook" />
                </a>
              </li>
              <li>
                <a href={data?.instaLink}>
                  <img src={instagram} alt="Instagram" />
                </a>
              </li>
              <li>
                <a href={data?.youtubeLink}>
                  <img src={youtube} alt="YouTube" />
                </a>
              </li>
            </ul>
          </div>

        </div>

        <div className="footer-container">
          {/* Opening Hours Section */}
          <div className="footer-section">
            <h4>Opening Hours</h4>
            <ul>
              {isLoading ? (
                <li>Loading...</li>
              ) : openingHours.length > 0 ? (
                openingHours.map((item: any, index: any) => (
                  <li key={index}>
                    {item.Day}: {item.Time}
                  </li>
                ))
              ) : (
                <li>No opening hours found</li>
              )}
            </ul>
          </div>

          {/* Categories Section */}
          <div className="footer-section">
            <h4>Categories</h4>
            <ul>
              {isLoading ? (
                <li>Loading...</li>
              ) : visibleCategories.length > 0 ? (
                visibleCategories.map((category: any) => (
                  <li key={category.id}>
                    <a href={`/category/${category.id}`}>{category.categoryTitle}</a>
                  </li>
                ))
              ) : (
                <li>No categories found</li>
              )}
            </ul>
            {/* Read More Button */}
            {categoryData.length > 8 && (
              <button className="read-more-btn" onClick={() => setShowAllCategories(!showAllCategories)}>
                {showAllCategories ? "Show Less" : "Read More"}
              </button>
            )}
          </div>

          {/* Quick Contact Section */}
          <div className="footer-section">
            <h4>Quick Contact</h4>
            <Form form={form} layout="vertical" className="contact-form" onFinish={submitHandler}>
              <Form.Item

                name="customerEmail"
                rules={[
                  { required: true, message: "Please enter your email!" },
                  { type: "email", message: "Please enter a valid email!" },
                ]}
              >
                <Input placeholder="Enter your email" />
              </Form.Item>

              <Form.Item

                name="message"
                rules={[{ required: true, message: "Please enter your message!" }]}
              >
                <Input.TextArea rows={4} placeholder="Enter your message" />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" block style={{ backgroundColor: "black" }}>
                  Send
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
        <div className="down-bar">
          <div>
            <p>Copyright ©2025 Kerala Plus. All Rights Reserved</p>
            <span><a href="/admin" style={{ color: "white" }}>Admin Login</a></span>
          </div>
          <div className="down-links">
            <span ><a href="/Contact" style={{ color: "white" }}>FAQ</a></span> |
            <span><a href="/Contact" style={{ color: "white" }}>Help Desk</a></span>
            | <span><a href="/Contact" style={{ color: "white" }}>Support</a></span>
            | <span><a href="/client" style={{ color: "white" }}>Client Login</a></span>
          </div>

        </div>
      </footer>
    </>
  );
}

export default FooterWeb;
